var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.994,
    height: 10.994,
    viewBox: "0 0 10.994 10.994",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings-line",
    transform: "translate(-13.042 14.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M16.717,14.667a1.917,1.917,0,1,0,1.917,1.917A1.9,1.9,0,0,0,16.717,14.667Zm0,3.286a1.369,1.369,0,1,1,1.369-1.369A1.356,1.356,0,0,1,16.717,17.952Z",
    transform: "translate(1.822 -25.09)",
    fill: "#758698",
    stroke: "#758698",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M13.249,7.03l-.962-.309-.206-.515.481-.893a.578.578,0,0,0-.1-.653l-.825-.825a.578.578,0,0,0-.653-.1l-.893.481-.515-.206-.309-.962a.558.558,0,0,0-.515-.378H7.58a.482.482,0,0,0-.481.412l-.309.962a1.518,1.518,0,0,0-.55.206l-.893-.481a.578.578,0,0,0-.653.1l-.825.825a.578.578,0,0,0-.1.653l.447.859c-.069.172-.137.378-.206.55l-.962.309a.558.558,0,0,0-.378.515V8.748a.547.547,0,0,0,.412.515l.962.309.206.515-.481.893a.578.578,0,0,0,.1.653l.825.825a.578.578,0,0,0,.653.1l.893-.481.515.206.309,1a.558.558,0,0,0,.515.378H8.748a.558.558,0,0,0,.515-.378l.309-1,.515-.206.893.481a.578.578,0,0,0,.653-.1l.825-.825a.578.578,0,0,0,.1-.653l-.481-.893.206-.515,1-.309a.558.558,0,0,0,.378-.515V7.58A.588.588,0,0,0,13.249,7.03Zm-.275,1.615-1.237.378-.034.172-.309.722-.1.172.618,1.134-.687.687-1.134-.618-.172.1a3.262,3.262,0,0,1-.722.309l-.172.034-.378,1.237H7.683L7.3,11.737,7.133,11.7l-.722-.309-.172-.1-1.134.618-.687-.687.618-1.134-.1-.172a3.262,3.262,0,0,1-.309-.722l-.034-.172L3.354,8.645V7.683l1.168-.344.069-.172A2.916,2.916,0,0,1,4.9,6.412L5,6.24,4.419,5.106l.687-.687,1.1.618.172-.1a2.916,2.916,0,0,1,.756-.309L7.3,4.556l.378-1.2h.962l.378,1.2.172.069a3.262,3.262,0,0,1,.722.309l.172.1,1.134-.618.687.687L11.29,6.24l.1.172a3.262,3.262,0,0,1,.309.722l.034.172,1.237.378Z",
    transform: "translate(10.375 -16.67)",
    fill: "#758698"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.f80e790ef93c0f87e7b8376f03db6f8e.svg";
export { ForwardRef as ReactComponent };